export default [
    {
        path: '/offer-items',
        name: '/offer-items',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Item de Oferta',
            icon: 'mdi-view-grid-plus-outline',
            breadcrumbs: [
                { text: 'Item de Oferta', disabled: true }
            ]
        }
    }
]